module.exports = __webpack_public_path__ + "static/img/bg-coins.00f53bed.webp";